export const SINGLE_SUB_CATEGORY = {
  FAIL_FETCH: "SINGLE_SUB_CATEGORY_FAIL_FETCH",
  SUCCESS_FETCH: "SINGLE_SUB_CATEGORY_SUCCESS_FETCH",
};
